import { EmbedTypes } from '../enums';
import { filterUrlArticleByPublisherDomain } from './articleUrlProcessor';
import { getElementAttribute } from './domElementsUtil';
import config from '../../config';

function removeDuplicateWidgetContainers(id) {
    if (typeof document !== 'undefined') {
        const allContainers = document.querySelectorAll(`#${id}`);
        if (!allContainers.length || allContainers.length === 1) return;

        for (let index = 1; index < allContainers.length; index++) {
            const element = allContainers[index];

            element.parentNode.removeChild(element);
        }
    }
}

function generateIdForWidgetContainer() {
    function makeid() {
        let text = '';
        const possible = 'abcdefghijklmnopqrstuvwxyz';

        for (let i = 0; i < 10; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
    }
    /* eslint prefer-template: 0 */
    return 'actionbutton' + makeid();
}

export function isReactIframeIntegration() {
    /* eslint-disable no-restricted-globals */
    return (
        typeof window !== 'undefined' &&
        !(self === top) &&
        window.location.href.indexOf('isNativeEmbed=true') !== -1
    );
}

function getWidgetContainerData(id) {
    if (isReactIframeIntegration()) return null;
    if (typeof document === 'undefined') return null;

    let container = document.getElementById(id);
    let embedType = null;

    if (container == null) {
        const currentScript = document.currentScript;
        const correspondingContainer = currentScript.previousElementSibling;

        if (correspondingContainer == null) return null;

        container = correspondingContainer;
        const hasWidgetId =
            getElementAttribute(
                container,
                'action-button-widget-id',
                'actionButtonWidgetId'
            ) != null;

        if (!hasWidgetId) {
            return null;
        }
        container.id = generateIdForWidgetContainer().toString();
        embedType = EmbedTypes.ReactOnlyWidgetId;
    } else {
        embedType = EmbedTypes.ReactOnly;
    }

    return {
        container: container,
        embedType: embedType
    };
}

function getWidgetPreviewId() {
    if (typeof document === 'undefined') return null;
    const element = document.getElementById(config.EMBED_ELEMENT);

    return getElementAttribute(element, 'widget-preview-id', 'widgetPreviewId');
}

function getWidgetRequestId(element) {
    if (element == null) return null;

    return getElementAttribute(
        element,
        'action-button-widget-id',
        'actionButtonWidgetId'
    );
}

export default function getPageData() {
    removeDuplicateWidgetContainers(config.EMBED_ELEMENT);

    let widgetContainerData = getWidgetContainerData(config.EMBED_ELEMENT);
    if (widgetContainerData == null) return null;

    const articleUrl = filterUrlArticleByPublisherDomain(
        widgetContainerData.container,
        widgetContainerData.embedType
    );

    return {
        articleUrl,
        widgetRequestId: getWidgetRequestId(widgetContainerData.container),
        widgetPreviewId: getWidgetPreviewId(),
        widgetContainer: widgetContainerData.container,
        widgetContainerId: widgetContainerData.container.id,
        //experimentId,
        //variationId,
        embedType: widgetContainerData.embedType
    };
}
